var __jsx = React.createElement;
import React from 'react';
import styles from '../../styles/rca/RCASearch.module.scss';

var RCANextSteps = function RCANextSteps(props) {
  var steps = props.steps;
  return steps.map(function (step, i) {
    var opacityClass = i == 1 ? styles.secondStep : i == 2 ? styles.thirdStep : '';
    return __jsx("div", {
      className: "".concat(styles.boxWrapper, " ").concat(styles.nextStep, " ").concat(opacityClass, " mb-3"),
      key: i
    }, step);
  });
};

export default RCANextSteps;